<template>
    <div class="text-center">
      <v-dialog v-model="dialog" max-width="700" persistent>
        <v-card>
          <v-card-title class="text-h5 orange darken-3 white--text">
            Duplicar estudiante en Q10
          </v-card-title>
  
          <v-card-text>  
            <p class="mt-4 mb-0">
                <b>Estudiante: </b> {{ persona.nombres }}  
            </p>
            <p class="my-0">
                <b>Documento: </b> {{ persona.num_doc }}
            </p>
            <p class="mt-4"> 
              Se abrirá una nueva pestaña del navegador donde se realizará automáticamente la autenticación con el portal ESAM.
            Una vez dentro, se cargará la lista de estudiantes inscritos en el programa.
            Busque al estudiante utilizando su número de documento y, en el botón de Opciones, seleccione “Vincular Q10”.
            Complete la información solicitada y proceda a vincular al estudiante. 
            </p> 
            <p class="mt-4 grey--text">
              Esta opción únicamente duplica los datos del estudiante en Q10.
            La matriculación en cada módulo debe realizarse manualmente dentro de la plataforma Q10.
            </p>
            
          </v-card-text>
  
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="orange" dark @click="enviar()"> Abrir opcion </v-btn>
            <v-btn color="grey" outlined tile @click="cerrar()"> Cerrar </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </div>
  </template>
  
  <script> 
  import {encryptToUpi} from '@/accessToken.js';

  export default {
      data() {
        return {
          loading: true,
          dialog: false,
          programa: {},
          persona:''
        };
      },
      methods: {
        async openmodal(prog, xpersona) { 
          this.dialog = true; 
          this.programa = prog   
          this.persona = xpersona       
        },
        cerrar() { 
            this.dialog = false;
        }, 
        async enviar(){ 
            const ahref = document.createElement('a')
            const id = this.programa.programa_id
            const tok = encryptToUpi()  
            const returnUrl = `/academico/inscripciones?prog_id=${id}&search=${this.persona.num_doc}`;
            // ahref.href = `https://upi.edu.pa/portal/upi/portal_login?t=${tok}&return=${encodeURIComponent(returnUrl)}`;
            ahref.href = `https://formulario.upi.edu.pa/portal_login?t=${tok}&return=${encodeURIComponent(returnUrl)}`;
            ahref.target = '_blank' 
            ahref.click()

            window.console.log('ahref.href',ahref.href);
            
        }
      },
    };
  </script>
  